import { Component,forwardRef,Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
MAT_DIALOG_DATA,
MatDialogActions,
MatDialogContent,
MatDialogRef,
} from '@angular/material/dialog';
import { DownloadComponent } from '../components';

@Component({
  selector: 'download-dialog',
  templateUrl: './download.dialog.html',
  styleUrls: ['./download.dialog.css'],
  imports: [MatDialogContent, MatDialogActions, MatButtonModule, forwardRef(() => DownloadComponent) ],
  standalone: true,
})
export class DownloadDialog {
  title: string;
  downloadId: number;
  message: string;
  constructor(private dialogRef: MatDialogRef<DownloadDialog>, @Inject(MAT_DIALOG_DATA) public data: { title: string, downloadId: number }) {
    this.title = data.title;
    this.downloadId = data.downloadId;
    // Observable.create()
  }

  close(ok: boolean) { return this.dialogRef.close(ok); }
}
